<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend>General Information </legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-8 mb-3">
                  {{emp_name}}
                </div>
              </div>
              <div class="form-row" v-if="id!==null">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  {{input_data.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Request Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr v-model="input_data.request_date" :config="config" ></flat-pickr>
                </div>
              </div>
              <div class="form-row" v-if="!this.$store.getters.companySettings.is_auto_approve">
                <label class="col-md-3">Project</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="option_project" v-model="input_data.project" label="name" :reduce="project=>project.id"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Activity Start</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr v-model="input_data.activity_start" :config="config" ></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">End of Activity</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr v-model="input_data.end_activity" :config="config" ></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nominal Cash Advance</label>
                <div class="col-md-5 mb-3">
                  <input type="number" class="form-control text-right"  v-model="input_data.cash_advance_amount" >
                </div>
                <div class="col-md-3 mb-2">
                  <v-select :options="option_currency" v-model="input_data.currency" :reduce="cur=>cur.id" label="code"></v-select>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Cash Advance Use</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.cash_advance_use" max-rows="6"></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mini TOR/Breakdown Budget</label>
                <div class="col-md-8 mb-3">
                  <b-form-file
                      v-model="input_data.file"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                  ></b-form-file>
                  <a :href="input_data.link_file" target="_blank">{{input_data.attachment_enc}}</a>
                </div>
              </div>
              <hr>
              <legend>Approval Information</legend>
              <list-supervisor :emp_id="input_data.emp_id"></list-supervisor>
            </div>
          </div>
        </div>
      </div>

    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="castat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="castat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BForm, BFormGroup, BFormInput, BFormTextarea, BFormFile, BButton, BModal} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
export default {
  name: "CashAdvanceInput",
  components:{
    ListSupervisor,
    Breadcrumb,
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BFormTextarea,
    BFormFile,
    BButton,
    BModal,
    vSelect
  },
  props:{
    project:{
      type:Array,
      required:true
    },
    id:{
      type:Number
    }
  },
  data(){
    return {
      emp_name:"",
      input_data:{
        request_date:"",
        project:"",
        activity_start:"",
        end_activity:"",
        cash_advance_amount:0,
        currency:"",
        cash_advance_use:"",
        number:'',
        file:[]
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        // minDate:'today',
        locale: {
          rangeSeparator: ' - '
        },
      },
      castat_id:0,
      option_project:[],
      option_currency:[]
    }
  },
  methods:{
    onSubmit(){

    },
    onReset(){
      this.$router.push({path:"/cash-advance-request"})
    },
    setData(){
      setTimeout(()=>{
        this.input_data.emp_id = this.$store.getters.empId
        if (this.id !== null){
          let payload = {lang:"en", id:this.id}
          AxiosCall.Get(payload, urlApi.cash_advance.detail).then(res=>{
            if (res.success){
              let data = res.atributes
              this.input_data.request_date =data.request_date
              this.input_data.project =data.project_id
              this.input_data.cash_advance_amount =data.cash_advance_amount
              this.input_data.activity_start =data.activity_start
              this.input_data.end_activity =data.activity_end
              this.input_data.currency =data.curr_id
              this.input_data.cash_advance_use =data.cash_advance_purpose
              this.input_data.number = data.number
              this.input_data.attachment_enc = data.attachment_enc
              this.input_data.link_file = `${process.env.VUE_APP_URL_API}${data.attachment_path}`
              this.input_data.emp_id = data.emp_id.toString()
            }else {
              this.errorMessage(res.message)
            }
          }).catch(e=>{
            this.errorMessage(e.response.data.message)
          })
        }


      }, 100)

    },
    resetModal(){
      this.$parent.id = null
      this.input_data = {
        request_date:"",
        project:"",
        activity_start:"",
        end_activity:"",
        cash_advance_amount:0,
        currency:"",
        cash_advance_use:"",
        file:[],
        emp_id:""
      }
      this.$refs.modal.hide()
    },
    handleOk(evt){
      evt.preventDefault()
      this.handleSubmit()
    },
    handleSubmit(){
      let payload = new FormData();
        payload.append("emp_id",this.$store.getters.empId)
        payload.append("user_id",this.$store.getters.userId)
        payload.append("project_id",this.input_data.project)
        payload.append("request_date",this.input_data.request_date)
        payload.append("activity_end",this.input_data.end_activity)
        payload.append("partner","")
        payload.append("curr_id", this.input_data.currency)
        payload.append("ca_amount",this.input_data.cash_advance_amount)
        payload.append("purpose",this.input_data.cash_advance_use)
        payload.append("castat_id",this.castat_id)
        payload.append("file",this.input_data.file)

      let url = urlApi.cash_advance.add
      if (this.id !== null){
        url = urlApi.cash_advance.update
        payload.append("ca_id", this.id)
        payload.append('number', this.input_data.number)
        AxiosCall.PutFormData(payload, url).then(res=>{
          if (res.success){
            this.successMessage(res.message)
            this.resetModal()
            this.$parent.getData()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.PostFormData(payload, url).then(res=>{
          if (res.success){
            this.successMessage(res.message)
            this.resetModal()

            this.$parent.getData()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }

    },
    showModal(){
      this.$refs['modal'].show()
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    getCurrency(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.currency.list).then(res=>{
        if(res.success){
          this.option_currency = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    }
  },
  mounted() {
    this.option_project = this.project
    let userPofile = this.$store.getters.userProfile
    this.emp_name = userPofile.data.attributes.emp_name
    this.input_data.emp_id = this.$store.getters.empId
    this.getCurrency()
  }
}
</script>